import { makeStyles } from 'tss-react/mui';

import { HEADER_HEIGHT } from '../../consts';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column-reverse',
    minHeight: '100vh',

    [theme.breakpoints.down('md')]: {
      paddingTop: `calc(${theme.spacing(4)} + ${HEADER_HEIGHT}px)`,
    },
  },

  content: {
    display: 'flex',
    flex: 1,

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(9),
    },
  },
}));
